import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedChangePersonOption.meta';

export type UseTrackClickedChangePersonOptionParams = {
  face_id: string;
  location: 'image-preview' | 'people-tab';
};

export const useTrackClickedChangePersonOption = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedChangePersonOption = useCallback(
    (params: UseTrackClickedChangePersonOptionParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedChangePersonOption };
};
